module.exports = __webpack_public_path__ + "static/media/team-details.3f284518.jpg";